import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from '../../../config/rbac/actions.ts';
import {ReloadRecordsButton} from "../buttons/ReloadRecordsButton.tsx";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";
import {FilterRecordsButton} from "../buttons/FilterRecordsButton.tsx";


// FNP-918: the index toolbar, composed here so what this module offers is
// readable in one place (§2).
//
// Order is [Reload, Filter] then Add — matching the sibling modules in this app
// and in console-app. Every element carries a stable `key`, which is the
// toolbar contract; `tools` is an ARRAY of buttons, never a hand-built <Group>.
//
// ⚠️ There is NO delete button, and none is missing. A report run is an
// immutable record of an executed job — the API exposes list/get/create only.
// See the matching note in tables/RecordsTable.tsx about row selection.
const useTools = () => {

        const {allowedActions} = useVerifiedPermissions()

        const tools = [
            <ReloadRecordsButton key='reload'/>,
            <FilterRecordsButton key='filter'/>,
        ];

        // Hidden, not disabled, when RBAC forbids the action (§2, §10).
        if (allowedActions.includes(rbacActions.CreateReportRun)) {
            tools.push(<AddRecordButton key='add'/>);
        }

        return tools;
    }
;

export const IndexPageHeader = () => {
    return (
        <SimplePageHeader
            title={I18n.get('Report Runs')}
            tools={useTools()}
        />
    );
};
